module.exports = __webpack_public_path__ + "static/organicanimalsmain-c3976cd42857571a29df18a9c23cdb3b.jpeg";